import * as THREE from "three";

export function addASAtoScene(scene, finalData) {
  if (!scene || !finalData || finalData.length === 0) return [];

  const createdSprites = [];

  const asaValues = finalData.map((d) => d.asa); 
  const minASA = Math.min(...asaValues); 
  const maxASA = Math.max(...asaValues);

  function getColorFromASA(value) {
    if (value == undefined || isNaN(value)) return new THREE.Color(0x000000);
    const t = Math.max(0, Math.min(1, value)); 
    const colorStops = [ 
      { stop: 1.0, color: new THREE.Color(0xffff00) },
      { stop: 0.95, color: new THREE.Color(0xfff200) },
      { stop: 0.9, color: new THREE.Color(0xffe600) },
      { stop: 0.85, color: new THREE.Color(0xffd700) },
      { stop: 0.8, color: new THREE.Color(0xffa500) },
      { stop: 0.75, color: new THREE.Color(0xff8c00) },
      { stop: 0.7, color: new THREE.Color(0xff7f00) },
      { stop: 0.6, color: new THREE.Color(0xff1a1a) },
      { stop: 0.5, color: new THREE.Color(0xff4c4c) },
      { stop: 0.4, color: new THREE.Color(0x330033) },
      { stop: 0.3, color: new THREE.Color(0x111111) },
      { stop: 0.2, color: new THREE.Color(0x000000) },
    ]; 
    
    for (let i = 0; i < colorStops.length - 1; i++) { 
      const left = colorStops[i]; 
      const right = colorStops[i + 1]; 
      if (t <= left.stop && t >= right.stop) { 
        const localT = (t - right.stop) / (left.stop - right.stop); 
        return left.color.clone().lerp(right.color, localT); 
      } 
    }

    // fallback
    return new THREE.Color(0x000000);
  }

  finalData.forEach((item, index) => {
    const { x, y, z } = item.coordinates || { x: 0, y: 0, z: 0 };
    const { asa } = item;

    const canvas = document.createElement("canvas");
    const size = 32;
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    ctx.fillStyle = getColorFromASA(asa)?.getStyle();
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.fill();

    ctx.fillStyle = "black";
    ctx.font = "bold 14px Arial";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText((asa * 100).toFixed(1), size / 2, size / 2);

    const texture = new THREE.CanvasTexture(canvas);
    const spriteMaterial = new THREE.SpriteMaterial({ map: texture });
    const sprite = new THREE.Sprite(spriteMaterial);

    // 🔹 Give it a recognizable name
    sprite.name = "IRRADIANCE_SPRITE";

    sprite.scale.set(0.7, 0.7, 0.7);
    sprite.position.set(x, y, z);
    sprite.renderOrder = 10;

    scene.add(sprite);
    createdSprites.push(sprite);
  });

  return createdSprites;
}
